import table from './table';

export var markdownItTable = function markdownItTable(md, options) {
  md.block.ruler.before('paragraph', 'table', table, {
    alt: ['paragraph', 'reference']
  });
};